<template>
  <div style="text-align: center">
    <h1>Page not found</h1>
    <p>
      The requested page was not found.<br/><br/>
      <router-link :to="{ name: 'basket' }">Back to basket</router-link>
    </p>
  </div>
</template>